
import Gps from "../../../assets/filled/Gps.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GpsIcon({ className, dataTestid = "GpsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Gps data-testid={dataTestid} className={classes} {...rest} />
  );
}
